import "babel-polyfill";
require("es6-promise").polyfill();
require("isomorphic-fetch");



// WEBPACK FOOTER //
// ./gatsby-browser.js